import { isProjectManagerRole } from "./roles";

export { isProjectManagerRole };

/**
 * Extract creator user/contact ids from API created_by (user with nested contact or legacy shapes).
 */
export function extractCreatorIds(createdBy) {
  if (createdBy == null || typeof createdBy !== "object") {
    return { userId: null, contactId: null };
  }

  const userId =
    createdBy.id ??
    createdBy.user_id ??
    createdBy.created_by_user_id ??
    null;

  const contactSource = createdBy.contact ?? createdBy;
  const contactId =
    contactSource?.id ??
    createdBy.contact_id ??
    null;

  return { userId, contactId };
}

/**
 * @param {object|null|undefined} createdBy
 * @param {{ id?: string|number, contactId?: number|null }} currentUser
 */
export function isRecordCreatedByCurrentUser(createdBy, currentUser) {
  if (createdBy == null || currentUser == null) return false;

  const { userId: creatorUserId, contactId: creatorContactId } =
    extractCreatorIds(createdBy);
  const currentUserId = currentUser.id ?? null;
  const currentContactId = currentUser.contactId ?? null;

  if (
    creatorUserId != null &&
    currentUserId != null &&
    String(creatorUserId) === String(currentUserId)
  ) {
    return true;
  }

  if (
    creatorContactId != null &&
    currentContactId != null &&
    String(creatorContactId) === String(currentContactId)
  ) {
    return true;
  }

  return false;
}

/**
 * Project managers may only update records they created; other roles follow permission only.
 */
export function canUpdateOwnedRecord(currentUser, hasUpdatePermission, createdBy) {
  if (!hasUpdatePermission) return false;
  if (!isProjectManagerRole(currentUser?.role)) return true;
  return isRecordCreatedByCurrentUser(createdBy, currentUser);
}
